var r=function(r){for(var a=[].concat(r),o=r.length-1;o>0;o--){var t=Math.floor(Math.random()*(o+1)),n=[a[t],a[o]];a[o]=n[0],a[t]=n[1]}return a};export{r as shuffle};
//# sourceMappingURL=index.module.js.map
